// src/services/dashboard/BookManager.js
import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/books`;
const PAGE_SIZE = 15; // Default page size matching frontend

const BookManager = {

 /**
 * Fetch paginated books using POST as per controller requirements
 * @param {Object} options - { page?: number, size?: number, userId?: number }
 */
async getAllBooks({ page = 0, size = PAGE_SIZE, userId = null, language } = {}) {
  try {
    const requestPayload = {
      page,
      size,
      userId,
      language
    };

    const response = await axios.post(`${BASE_URL}/getAllBooks`, requestPayload);
    return response.data.responseData;
  } catch (err) {
    console.error("Error fetching books:", err.response?.data || err.message);
    throw err;
  }
},

async getBookById(id, userId = null) {
  const response = await axios.post(`${BASE_URL}/get-book`, {
    id: id,
    userId: userId
  });
  return response.data.responseData;
},


  async getBooksByAuthor(authorId, userId) {
    const requestData = {
      authorId: authorId,
      userId: userId,
    };
    const response = await axios.post(`${BASE_URL}/author/all`, requestData);
    return response.data.responseData;
  },

  async getBooksByCategory(categoryId, userId) {
    const requestData = {
      categoryId: categoryId,
      userId: userId,
    };

    const response = await axios.post(`${BASE_URL}/category/all`, requestData);
    return response.data.responseData;
  },


  async searchBooks(keyword, userId) {
    const response = await axios.post(`${BASE_URL}/search`, {
      keyword: keyword,
      userId: userId
    });
    return response.data.responseData;
  },

    /**
   * Search all entities (books, authors, etc.) based on a keyword
   * @param {string} keyword - The search term
   * @param {number|null} userId - Optional user ID for personalization
   * @returns {Promise<Object>} - Search response data including books, authors, etc.
   */
    async searchAllEntities(keyword, userId = null) {
      try {
        const response = await axios.post(`${BASE_URL}/search/all`, {
          keyword,
          userId,
        });
        return response.data.responseData;
      } catch (err) {
        console.error("Error searching all entities:", err.response?.data || err.message);
        throw err;
      }
    },

    /**
   * Fetch top-rated books (highest to lowest average rating)
   * @param {number} limit Number of books to return (default 10)
   * @param {number|null} userId Optional user ID for cart/wishlist flags
   */
  async getTopRatedBooks(limit = 15, userId = null) {
    try {
      const response = await axios.get(`${BASE_URL}/top-rated`, {
        params: { limit, userId }
      });
      return response.data.responseData;
    } catch (err) {
      console.error("Error fetching top-rated books:", err.response?.data || err.message);
      throw err;
    }
  },

  async getRecommendedBooks() {
    try {
      const token = localStorage.getItem("authToken");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await axios.get(`${config.url}/api/recommendations`, {
        headers
      });
      return response.data;
    } catch (err) {
      console.error("Error fetching recommended books:", err);
      // Fallback to empty array if something fails
      return [];
    }
  }
};

export default BookManager;
